<template lang="pug">
  .container(:class="{loading: loading}")
    .header(:class="{minimal: displayProducts}")
      h3.contrast-text.text-center De perfecte wijn bij jouw gerecht
      .line
      h1.contrast-text.text-center Wijnwijzer
      form#ingredientsForm.searchbox(v-on:submit="onSubmit")
        .input-group
          label.contrast-text.tagline(for="ingredients") Vind je wijn door te zoeken op de naam van je gerecht òf plak je ingrediëntenlijst van je recept hierin en klik op zoeken.
          div.search-input-field(ref="filter")
            vue-autosuggest.search(
                v-model="filter"
                :section-configs="sectionConfigs"
                :suggestions="filteredOptions"
                :input-props="{id:'autosuggest__input', class:'autosuggest__input', placeholder:'Zoeken naar...'}",
                :get-suggestion-value="getSuggestionValue"
                :should-render-suggestions="shouldRenderSuggestions"
              )
              template(slot-scope='{suggestion}')
                span.my-suggestion-item {{suggestion.item}}
            span.input-group-btn
              button#submitButton(type='submit')
                svg.icon(viewbox='0 0 16 16')
                  path(d='M6.4.816c.418.072.851.096 1.251.224 1.962.627 3.171 1.96 3.518 3.994.237 1.386.028 2.721-.802 3.905-.103.146-.006.205.073.284l4.221 4.221c.339.339.424.731.253 1.125-.291.67-1.106.826-1.631.305-.944-.938-1.884-1.882-2.824-2.823-.502-.501-1.007-.998-1.501-1.507-.107-.11-.184-.116-.31-.043-1.68.966-4.261.847-5.837-.515C1.598 8.936.99 7.625 1 6.007c.006-.864.134-1.683.541-2.444.868-1.624 2.222-2.536 4.062-2.712.078-.007.156-.023.233-.035H6.4zm2.865 5.162c.001-1.848-1.301-3.159-3.141-3.163C4.282 2.81 2.966 4.14 2.971 5.99c.006 1.84 1.324 3.16 3.154 3.154 1.844-.004 3.139-1.318 3.14-3.166z')
                span.search-text zoeken
    .refine(v-if="displayProducts")
      ul.refinement-accordion__list(v-if="colorChoicesCalculated.length > 0")
        li.refinement-accordion__list-item(v-for="(item, index) in colorChoicesCalculated")
          span.a-radio(:class="{checked: colorChoice===item.color}" v-on:click="setColorChoice(item.color)" role='radio' tabindex='0' :aria-label="`Checkbox: Verfijnen op wijnsoort: ${item.name}`")
            span.radio__label
              | {{item.name}}
              span.radio__focus-helper
      ul.refinement-accordion__list
        li.refinement-accordion__list-item(v-for="(item, index) in prijzenkeuze")
          span.a-radio(:class="{checked: prijs===index}" v-on:click="setPrijs(index)" role='radio' tabindex='0' :aria-label="`Checkbox: Verfijnen op Prijs: ${item.title}`")
            span.radio__label
              | {{item.title}}
              span.radio__focus-helper

    #results(v-if="displayProducts && !noresult")
      .feedback Lekker bij&nbsp;
        strong {{searchString}}
      div.result-panel
        div.o-grid.product-row(ref="grid" v-html="rawHtml" data-hook-infinite-grid-wrapper="" js-hook-inview data-inview-offset-bottom="100" data-inview-threshold="0.5" data-inview-trigger="event::setpage" data-inview-persistent="true" data-page-number="0" data-page-size="12.0")
    div.noresult(v-if="noresult===true")
      h2 Er zijn geen resultaten
      p Zoek je naar?
      select(v-model="selectedsuggestion" @change="onQuickSelect(selectedsuggestion)")
        option(:selectedsuggestion="selectedsuggestion" value="") Kies gerecht...
        option(v-for="(item, index) in searchwords[0].data"  v-bind:value="item") {{item}}
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { VueAutosuggest } from 'vue-autosuggest'

const JS_HOOK_GRID = '[data-hook-infinite-grid-wrapper]'

export default {
  name: 'IngredientsForm',
  components: {
    VueAutosuggest
  },
  props: {
    startvalue: String
  },
  data: function () {
    return {
      selectedsuggestion: '',
      settingsPromise: null,
      matchResult: null,
      courseMatchResult: null,
      displayProducts: false,
      filter: '',
      searchString: '',
      noresult: false,
      rawHtml: '',
      prijs: null,
      prijzenkeuze: [
        {
          min: 0,
          max: 10,
          title: 'Tot 10 euro'
        },
        {
          min: 10,
          max: 20,
          title: 'tussen 10 en 20 euro'
        },
        {
          min: 20,
          max: 50,
          title: 'meer dan 20 euro'
        }
      ],
      colorChoice: null,
      colorChoices: [
        { name: 'rood', color: 'red', path: 'rode-wijn' },
        { name: 'wit', color: 'white', path: 'witte-wijn' },
        { name: 'rosé', color: 'rose', path: 'rose-wijn' }
      ],
      sectionConfigs: {}
    }
  },
  mounted: function () {
    const searchFunction = this.requestRecommedation
    const setFilterFunction = this.setFilter
    this.settingsPromise = this.getSettings()
    this.filter = this.startvalue || ''
    this.sectionConfigs = {
      recepes: {
        limit: 3,
        label: 'Recepten',
        onSelected: function (item) {
          this.filter = item.item
          searchFunction(item.item)
        }
      },
      ingredients: {
        limit: 6,
        label: 'Ingrediënten',
        onSelected: function (item, words) {
          setFilterFunction(words)
          searchFunction(words)
        }
      }
    }
    this.$nextTick(function () {
      this.requestRecommedation()
    })
  },
  methods: {
    ...mapActions([
      'recordAnalyticsEvent',
      'getRecommedation',
      'getProducts',
      'getCourse',
      'getSettings'
    ]),
    setFilter (value) {
      this.filter = value
    },
    getSuggestionValue (suggestion) {
      const filtervalues = this.filterwords
      const filter =
        suggestion.name === 'recepes'
          ? suggestion.item
          : filtervalues.length > 1
            ? `${filtervalues.slice(0, -1).join(', ')}, ${suggestion.item}`
            : suggestion.item
      return filter
    },
    onSubmit (event) {
      event.preventDefault()
      event.stopPropagation()
      this.requestRecommedation()
    },
    onQuickSelect (value) {
      this.setFilter(value)
      this.requestRecommedation(value)
    },
    shouldRenderSuggestions (size, loading) {
      return size > 0 && this.filter.length > 0 && !loading
    },
    requestRecommedation (_searchText) {
      this.selectedsuggestion = ''
      this.courseMatchResult = null
      this.matchResult = null
      const searchText = _searchText || this.filter
      this.searchString = searchText
      if (!searchText || searchText.length < 0) {
        this.displayProducts = false
        this.noresult = false
        return
      }
      this.filter = searchText
      this.recordEvent('search', searchText)
      this.noresult = false
      this.colorChoice = null
      this.prijs = null
      this.getCourse(searchText)
        .then(tasteProfileData => {
          if (tasteProfileData.result && tasteProfileData.result.matched) {
            this.courseMatchResult = tasteProfileData.result
            return this.loadProduct()
          }
          throw Error('no data found')
        })
        .catch(() => {
          this.requestRecommedationByIngredient(searchText)
        })
    },
    requestRecommedationByIngredient (searchText) {
      this.getRecommedation(searchText)
        .then(tasteProfileData => {
          if (
            tasteProfileData.result &&
            tasteProfileData.result.matched.length > 0
          ) {
            this.matchResult = tasteProfileData.result
            return this.loadProduct()
          }
          throw Error('no data found')
        })
        .catch(() => {
          this.recordEvent('search error', searchText)
          this.displayProducts = true
          this.noresult = true
        })
    },
    recordEvent (action, label) {
      this.recordAnalyticsEvent({ category: 'wijnwijzer', action, label })
    },
    setPrijs (prijsIndex) {
      this.prijs = prijsIndex
      this.recordEvent('set filter price', this.prijzenkeuze[this.prijs].title)
      this.loadProduct()
    },
    setColorChoice (color) {
      this.colorChoice = color
      this.recordEvent('set filter color', this.colorChoice)
      this.loadProduct()
    },
    loadProduct () {
      this.noresult = false
      this.rawHtml = ''
      const productInitEvent = new CustomEvent('productcards::init')
      const products = this.courseMatchResult
        ? this.courseMatchResult.matched.products
        : []
      const tasteprofiles = this.courseMatchResult
        ? this.courseMatchResult.matched.tasteprofiles
        : this.findbestTasteprofileMatch(this.matchResult)
      this.loadCourseProduct(
        products,
        tasteprofiles
      )
        .then(data => {
          if (data === '') throw Error('no data found')
          this.rawHtml = data
          this.recordEvent('request products result', 'success')
          this.displayProducts = true
          this.$nextTick(function () {
            this.$refs.filter.scrollIntoView()
            window.dispatchEvent(productInitEvent)
          })
        })
        .catch(err => {
          this.recordEvent('request products error', err.toString())
          this.displayProducts = true
          this.noresult = true
        })
    },
    loadCourseProduct (products, tasteProfileOrCategory) {
      const prijs = this.prijzenkeuze[this.prijs]
      let promiseList = []
      return this.settingsPromise.then(() => {
        if (products.length > 0) {
          promiseList = products.map(productId => {
            return this.getProducts({
              search: productId,
              price: prijs
            }).then(this.processGrid)
          })
        }
        const reducer = (accumulator, currentValue) => {
          const tp = this.settings.tasteprofiles.find(item => item.name === currentValue)
          if (tp) {
            accumulator.tasteProfiles.push(tp)
          } else {
            const cat = this.settings.categories.find(item => item.name === currentValue)
            if (cat) {
              accumulator.categories.push(cat)
            }
          }

          return accumulator
        }
        const { tasteProfiles, categories } = tasteProfileOrCategory.reduce(reducer, { tasteProfiles: [], categories: [] })
        if (tasteProfiles.length > 0) {
          promiseList.push(
            this.getProducts({
              tasteProfile: encodeURIComponent(tasteProfiles.map(item => item.name).join('|')),
              price: prijs
            }).then(this.processGrid)
          )
        }

        if (categories.length > 0) {
          promiseList = [...promiseList, ...categories.map(item => this.getProducts({
            path: item.search,
            price: prijs
          }).then(this.processGrid))]
        }

        if (promiseList.length === 0) {
          return Promise.reject(new Error('no result'))
        }

        return Promise
          .all(promiseList)
          .then(result => result.join(''))
          .then(html => {
            const content = new DOMParser().parseFromString(html, 'text/html')
            const products = content.querySelectorAll('.product-grid__product')
            const getProductPrice = (product) => {
              const productDataElement = product.querySelector('.c-product-tile ')
              const productData = productDataElement && productDataElement.dataset.product ? JSON.parse(productDataElement.dataset.product) : {}
              return productData.price - productData.discount
            }
            const selectedProducts = [...products]
              .slice(0, 3)
              .sort((producta, productb) => {
                return getProductPrice(producta) > getProductPrice(productb) ? 1 : -1
              })
            return selectedProducts.map(element => element.outerHTML).join('')
          })
      })
    },
    processGrid (gridData) {
      const content = new DOMParser().parseFromString(gridData, 'text/html')
      const grid = content.querySelector(JS_HOOK_GRID)
      return grid ? grid.innerHTML : ''
    },
    findbestTasteprofileMatch (matchResult) {
      matchResult = this.colorChoice
        ? matchResult.sortedMatch.filter(
          item => item.color === this.colorChoice
        )
        : [...matchResult.sortedMatch]
      return matchResult
        .filter(item => item.value === matchResult[0].value)
        .map(item => item.name)
    },
    loadTasteProfileProduct () {
      const prijs = this.prijzenkeuze[this.prijs]
      const matchResult = this.colorChoice
        ? this.matchResult.sortedMatch.filter(
          item => item.color === this.colorChoice
        )
        : [...this.matchResult.sortedMatch]
      const bestResults = matchResult.filter(
        item => item.value === matchResult[0].value
      )
      const tp = bestResults.map(item => item.name).join('|')

      if (!tp) {
        this.displayProducts = true
        this.noresult = true
        return
      }
      this.recordEvent('request products', tp)
      return this.getProducts({
        tasteProfile: encodeURIComponent(tp),
        price: prijs
      })
        .then(data => {
          const content = new DOMParser().parseFromString(data, 'text/html')
          const grid = content.querySelector(JS_HOOK_GRID)

          this.displayProducts = true
          this.rawHtml = grid.outerHTML
          this.recordEvent('request products result', 'success')
          this.$nextTick(function () {
            this.$refs.filter.scrollIntoView()
            // window.dispatchEvent(productInitEvent)
          })
        })
        .catch(err => {
          this.recordEvent('request products error', err.toString())
          this.displayProducts = true
          this.noresult = true
        })
    },
    onChange (event) {
      if (!event.shiftKey && event.key === 'Enter') {
        this.filter = this.filter.trim()
        this.onSubmit(event)
      }
    }
  },
  watch: {
    loading: function (newState, oldState) {
      const loadEvent = new CustomEvent(
        `loader::${newState ? 'show' : 'hide'}`
      )
      window.dispatchEvent(loadEvent)
    }
  },
  computed: {
    ...mapState({
      loading: state => state.public.loading,
      settings: state => state.public.settings
    }),
    searchwords: function () {
      return this.settings.autosuggest
    },
    colorChoicesCalculated: function () {
      return this.colorChoices
        .map(color => ({
          count: this.matchResult
            ? this.matchResult.sortedMatch.filter(
              item => item.color === color.color
            ).length
            : 0,
          ...color
        }))
        .filter(color => color.count > 0)
    },
    filterwords () {
      return this.filter
        .replace(/,/g, ' ')
        .replace(/\s{2,}/g, ' ')
        .trim()
        .split(' ')
    },
    filteredOptions () {
      const searchword = [...this.filterwords].reverse()[0].toLowerCase()
      const recepes = {
        name: 'recepes',
        data: this.searchwords[0].data.filter(option => {
          return option.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
        })
      }

      const ingredients = {
        name: 'ingredients',
        data: this.searchwords[1].data.filter(option => {
          return option.toLowerCase().indexOf(searchword) > -1
        })
      }

      return [recepes, ingredients]
    }
  }
}
</script>

<style lang="sass" scoped>

.header  
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4) 35%, rgba(0, 0, 0, 0.4) 62%, rgba(0, 0, 0, 0)), url('../assets/header.jpg')
  background-size: cover
  background-position: center
  min-height: calc(100vh - 102px)
  transition:  all 0.2s linear
  padding: 40px 0 20px 0
  text-align: center
  .contrast-text
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black
  h1
    font-size: 4.2rem
  h3
    font-size: 1.5rem
  h1, h3, label
    color: white
  @media only screen and (min-width: 47.125em)
    min-height: calc(100vh - 160px)
  &.minimal
    margin-bottom: 20px
    min-height: 0
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.7) 35%, rgba(255, 255, 255, 0.71) 62%, rgba(255, 255, 255, 0.8)), url('../assets/header.jpg')
    h1, h3, label
      color: black
    @media only screen and (min-width: 47.125em)
      min-height: 0
    .tagline
      text-shadow: none
    .contrast-text
      text-shadow: none
    .line
      background: black
  .line
    display: inline-block
    width: 50px
    height: 6px
    background: white
    margin: 20px 0
  h1
    margin-bottom: 20px
  @media only screen and (min-width: 47.125em)
    padding: 80px 0 50px 0
    h1
      margin-bottom: 60px
.match
  background: white
  display: inline-block
  color: black
  padding: 10px 20px
  border-radius: 4px
  margin: 10px
.loading
  opacity: 0.5

.input-group
  max-width: 500px
  margin-bottom: 20px
.searchbox
  display: flex
  justify-content: center
  .tagline
    min-height: 30px
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5)
    font-size: 20px
    font-weight: 500
    font-style: normal
    font-stretch: normal
    line-height: 1.5
    letter-spacing: normal
    text-align: center
    color: #ffffff
    margin-bottom: 20px
    display: block
  .search-input-field
    display: flex
    margin: 0 40px
    textarea[type=search]
      border: 1px solid #e7e6da !important
      background-color: #fff
      height: 44px
      color: black
      width: 100%
      flex: grow
      padding: 10px 15px
    .input-group-btn button
      position: relative
      height: 44px
      background-color: #f47920
      padding: 0 15px
      font-size: 15px
      font-weight: bold
      letter-spacing: 0.03px
      text-transform: uppercase
      line-height: 1
      .icon
        margin: 0
        fill: #fff
        width: 16px
        height: 16px
      .search-text
        display: none
      @media only screen and (min-width: 47.125em)
        padding: 0 30px 0 15px
        .search-text
          display: inherit
        .icon
          margin: 0 10px 0 0

.alternative-text
  text-align: center
  line-height: 10rem

#results
  .feedback
    font-size: 20px
    font-weight: 500
    font-style: normal
    font-stretch: normal
    line-height: 1.5
    letter-spacing: normal
    strong
      color: #f47920
  .result-panel
    padding: 0 0 80px 0

.product-row
  justify-content: space-around

.refine
  display: flex
  flex-direction: row
  justify-content: space-between
  @media only screen and (max-width: 47.125em)
    flex-direction: column
.refinement-accordion__list
  display: flex
  margin: 0
  .refinement-accordion__list-item
    margin-right: 20px

.product-block .product-buttons .button
  margin-left: 0 !important
  margin-right: 0 !important

.noresult
  padding: 0 0 40px 0
  text-align: center
</style>
<style lang="sass">
  .autosuggest-container
    display: flex
    justify-content: center
    width: 280px

  #autosuggest
    position: relative
    width: 100%
    display: block

  .autosuggest__results-item--highlighted
    background-color: #f47920

  .autosuggest__input
    color: black
    border: 1px solid #e7e6da !important
    background-color: #fff
    height: 44px
    color: black
    width: 100%
    padding: 10px 15px
    font-size: 16px

  .autosuggest__results-container
    position: absolute
    z-index: 1
    width: 100%
    max-height: 50vh
    background: white
    text-align: left
    color: black
    overflow: auto
    border: 1px solid black
    &:empty
      display: none

  .autosuggest__results-item
    padding: 8px !important

  .autosuggest__results-before
    padding: 2px 0 !important
    background: #393537
    color: white
    font-weight: bold
    text-align: center
  .autosuggest__results
    li:only-child
      display: none
  .is--v2 .s-rich-text .o-grid
    display: flex
    margin-left: 0
    margin-right: 0
    gap: 15px
    width: 100%
    .product-grid__product
      display: none
      flex: 1 1 0px
      .c-product 
        height: 100%
        a
          color: #393537
          font-weight: 600
          text-decoration: none
          outline: none
      @media only screen and (max-width: 754px)
        &:nth-child(1)
          max-width: none
          width: 100%
          flex-basis: 100%
      &:nth-child(-n+3)
        display: block
  .refine
    .a-radio
      outline: none

  .s-rich-text .container
    .header
      min-height: 0
    a
      color: #393537
      font-weight: 600
      text-decoration: none
      outline: none
    li
      margin: 0
      &::before
        display: none !important

</style>
